"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  wrapper: {
    maxWidth: props => {
      return props.maxWidth;
    },
    margin: "auto"
  }
}));

const ArticleGrid = ({
  className,
  maxWidth = 720,
  children
}) => {
  const classes = useStyles({
    maxWidth
  });
  return _react.default.createElement("section", {
    className: className || classes.wrapper
  }, children);
};

var _default = ArticleGrid;
exports.default = _default;
module.exports = exports.default;